export default __webpack_public_path__ + "static/vijay-f86620fe0184b08579f306735c32819c.png";